import type { EmploymentStatus } from '@chukua/common';

export const EMPLOYMENT_STATUS_LABELS: Record<EmploymentStatus, string> = {
  active: 'Active',
  suspended: 'Suspended',
  left: 'Left',
};

export const EMPLOYMENT_STATUS_COLORS: Record<EmploymentStatus, string> = {
  active: 'success',
  suspended: 'warning',
  left: 'default',
};
